"use client";

import { c as _c } from "react/compiler-runtime";
import { APIProvider } from "@vis.gl/react-google-maps";
export function GoogleMapProvider(t0) {
  const $ = _c(7);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["geometry"];
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== children || $[5] !== props.apiKey) {
    t2 = <APIProvider apiKey={props.apiKey} libraries={t1}>{children}</APIProvider>;
    $[4] = children;
    $[5] = props.apiKey;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}